module.exports = __webpack_public_path__ + "img/20180815_151629_186.2b3d4e48.jpg";